// extracted by mini-css-extract-plugin
export default {"authButton":"AccountAuthButton--authButton--rndUK","placeholder":"AccountAuthButton--placeholder--qoGWY","facebookBlue":"AccountAuthButton--facebookBlue--ck4Ti"};